import classNames from 'classnames/bind';
import React from 'react';

import styles from './NoResults.module.scss';

const cx = classNames.bind(styles);

interface NoResultsProps {
  title?: string;
  infoText?: string;
}

const NoResults = ({ title = 'No results found', infoText }: NoResultsProps): React.ReactElement => {
  return (
    <div className={cx('body')} data-testid="no-results">
      <p className={cx('main-msg')}>{title}</p>
      <p>{infoText}</p>
    </div>
  );
};

export default NoResults;
